import axios from "axios";

interface GetVehiclePlatesParames {
    locationCode: string
}

interface GetVehiclePlatesReturn {
    vehicles: {
        value: string,
        label: string
    }[]
}

export const getVehiclePlates = async (params: GetVehiclePlatesParames): Promise<GetVehiclePlatesReturn> => {
    const response = await axios.get('/booking/instool/plates', {
        params
    });
    return response.data;
};